export default __webpack_public_path__ + "static/no-results-6f02473b6b101aa01a936c894d609ea6.png";